import { Dropdown } from "react-bootstrap"
import ProfileImage from "./ProfileImage"
import React, { useState } from "react"
import Label from "./Label"
import { CompanyData, SessionDetails } from "../api/auth/actions"
import { useAuth } from "../api/auth/store"
import { useNavigate } from "react-router"
import useUXStore from "../api/ux/store"
import { getErrorMessage } from "../utils/errors"
import { setLastCompany } from "../utils/lastCompany"

type AccountProps = {
    user: SessionDetails | null
}
const Account: React.FC<AccountProps> = ({ user }) => {
    const [signingOut, setSigningOut] = useState(false)
    const { pushHome, addToast, refreshDialog, hideDialog } = useUXStore(state => state)
    const { signout, companies, retrieveSessionCom, currentCompany, setSessionCom } = useAuth(state => state)
    const navigate = useNavigate()
    if (user === null) return <></>
    const onToggle = (toggle: boolean) => {
        if (companies === null)
            retrieveSessionCom()
    }
    const executeSignout = (all: boolean) => {
        setSigningOut(true)
        // Show loading spinner in the modal
        refreshDialog({
            id: "signout_confirm",
            title: "Signing Out",
            visible: true,
            content: (
                <div className="text-center py-4">
                    <div className="spinner-border text-primary mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="text-muted mb-0">Ending session...</p>
                </div>
            )
        })

        signout(all)
            .then(code => {
                switch (code) {
                    case "200":
                    case "session_invalid":
                        hideDialog("signout_confirm")
                        window.location.reload()
                        break;
                    default:
                        setSigningOut(false)
                        hideDialog("signout_confirm")
                        addToast("Sign Out Failed", "Unable to complete signout.", null, "danger")
                        break;
                }
            })
            .catch(err => {
                setSigningOut(false)
                hideDialog("signout_confirm")
                addToast("Sign Out Failed", "An error occurred during signout.", null, "danger")
            })
    }
    const handleSignoutClick = () => {
        refreshDialog({
            id: "signout_confirm",
            title: "Confirm Sign Out",
            visible: true,
            content: (
                <div className="p-3 text-center">
                    <div className="mb-4">
                        <i className="bi bi-box-arrow-right text-primary" style={{ fontSize: "3rem" }}></i>
                    </div>
                    <h5 className="fw-bold mb-3 text-dark">Sign Out of Applications</h5>
                    <p className="text-muted px-2 mb-4">
                        Would you like to sign out of all applications connected to CoreONE Passport (cpass) on this device?
                    </p>
                    <div className="d-grid gap-2">
                        <button
                            className="btn btn-danger py-2.5 fw-semibold d-flex align-items-center justify-content-center gap-2"
                            onClick={() => executeSignout(true)}
                        >
                            <i className="bi bi-shield-lock-fill"></i>
                            Sign out of all applications on this device
                        </button>
                        <button
                            className="btn btn-outline-secondary py-2.5 fw-semibold"
                            onClick={() => executeSignout(false)}
                        >
                            Sign out CPASS only
                        </button>
                        <button
                            className="btn btn-link text-decoration-none text-muted py-2 mt-1"
                            onClick={() => hideDialog("signout_confirm")}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )
        }, true)
    }
    const onSelectedCompany = async (com: CompanyData) => {
        if (currentCompany === com.id) return
        const res = await setSessionCom(com.id)
        if (res === "200") {
            // remember it so the next sign-in lands on this company
            setLastCompany(com.id)
            navigate("/manage/me")
            pushHome()
        } else {
            const message = getErrorMessage(res) || "Unable to switch company at this time."
            addToast("Switch Failed", message, null)
        }
    }
    // TODO: update company selection style
    return <div className="topbar-btn">
        <Dropdown onToggle={onToggle}>
            <Dropdown.Toggle className="dropdownt" size="sm" variant="" id="dropdown-basic">
                {user && <ProfileImage name={user!.dis} size={30} bgcolor="rgb(155, 186, 255)" />}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item><Label>{"Hello " + user!.dis}</Label></Dropdown.Item>
                {companies && companies.map((company) =>
                    <Dropdown.Item onClick={() => onSelectedCompany(company)}>
                        {company.name}
                    </Dropdown.Item>)}
                <Dropdown.Item disabled={signingOut} onClick={handleSignoutClick}>Sign out</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    </div>
}

export default Account